import React, { useEffect } from "react";
import List from "src/pages/high_risk/register/list";
import Header from "src/pages/high_risk/register/header";

import { useUserContext } from "src/contexts/userContext";
import { useHighRiskContext } from "src/contexts/high_risk/highriskContext";
import _ from "lodash";
import AssignedWorkInbox from "src/components/hazard/AssignedWorkInbox";
import moment from "moment";

const Index = () => {
  const { user, message } = useUserContext();
  const { state, dispatch } = useHighRiskContext();

  // useEffect(() => {
  //   if (user.loggedIn) {
  //     var result = [];
  //     var roles = _.split(user.roles, " ");
  //     _.map(roles, (item) => {
  //       var role = _.split(item, "_");
  //       result.push(_.toInteger(role[1]));
  //     });

  //     dispatch({ type: "STATE", data: { product_ids: result } });
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [user.loggedIn]);

  // const { state, dispatch } = useProductContext();

  /**
   * Банер дээрх аюулаас ӨЭА наряд үүсгэнэ.
   *
   * ⚠ ӨЭА-гийн маягт нь §1–§7 хэсэгтэй (гарын үсэг, хангамж, бригад,
   *   ээлж) бөгөөд тэдгээр нь наряд ХАДГАЛАГДСАНЫ ДАРАА л нээгддэг.
   *   Тиймээс энд зөвхөн ЭХНИЙ хэсгийг урьдчилан бөглөнө — ажлын
   *   агуулга, нэгж, хугацаа. Үлдсэнийг нь хэрэглэгч ердийнхөөрөө
   *   гүйцээнэ.
   *
   * ⚠ `from_hazard_id` нь модал дотор үлдэж, наряд амжилттай
   *   хадгалагдмагц `link-work` дуудагдана. Ингэснээр банераас
   *   хасагдана — хүн гараар холбохыг найдвал мартана.
   *
   * ⚠ Бүх талбарыг АНХДАГЧ руу тавина (list.js-ийн «Нэмэх» товчтой
   *   ижил). Эс бөгөөс өмнөх засварын утга шинэ наряд руу дамжина.
   */
  const onCreateFromHazard = (hz) => {
    dispatch({
      type: "STATE",
      data: {
        register: {
          modal: true,
          modal_approve: false,
          id: 0,
          yearc: moment(),
          type_id: 0,
          hr: null,
          tseh_code: null,
          tseh_name: null,
          negj_code: null,
          negj_name: null,
          department: hz.insert_dept_code || null,
          department_code: hz.insert_dept_code || null,
          department_name: hz.insert_dept_name || null,
          // Ажлын агуулга нь аюулын тайлбар — хэрэглэгч засаж болно
          jobdesc: hz.description || null,
          comment:
            `Аюулын мэдээлэл ${hz.report_number || "#" + hz.id} -аас үүсгэв` +
            (hz.location_text ? ` · ${hz.location_text}` : ""),
          start_date: null,
          // Хуваарилахад өгсөн хугацаа байвал төгсгөлийн огноо болгоно
          end_date: hz.sla_deadline
            ? moment(String(hz.sla_deadline).slice(0, 10))
            : null,
          selected_consequence: null,
          selected_probability: null,
          matrix_score: null,
          matrix_grade: null,
          matrix_id: 0,
          approve_type_id: 0,
          approve_comment: null,
          readonly: false,
          // ⚠ Энэ л талбар холбоосыг үүсгэнэ
          from_hazard_id: hz.id,
        },
      },
    });
  };

  return (
    <div className=" card flex  p-2 border rounded text-xs">
      {/* ⚠ ХАБ хэлтсээс хуваарилагдсан аюулын ажил — ЭНД гарна.
          Ажил үүсгэдэг газар нь энэ хуудас тул даалгавар мөн энд
          харагдах ёстой; өөр хуудас руу явж хайх алхам нэмэгдэх бүрд
          гүйцэтгэлийн магадлал буурна. */}
      <AssignedWorkInbox workType="OEA" onCreate={onCreateFromHazard} />
      <Header />
      <List />
    </div>
  );
};

export default React.memo(Index);
